import DailyInsights from "./daily-insights";

export default DailyInsights;